import { SvgIcon, SvgIconProps } from "@material-ui/core";
import { css, keyframes } from "emotion";
import React, { memo } from "react";

const keyframeShinning = keyframes`
  from, 40%, 50%, 60%, to {
    fill: #ffac33;
  }
  45%, 55% {
    fill: #fff;
  }
`;

const cssMedal = css`
  label: medal;
  fill: #ffac33;
  animation: ${keyframeShinning} 3s linear infinite;
`;

const MedalIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 36 36" {...props}>
      <path
        fill="#55ACEE"
        d="M25 0H11C9.896 0 9 .896 9 2v11s0 1 1 2l6.429 5h3.142L26 15c1-1 1-2 1-2V2c0-1.104-.896-2-2-2z"
      />
      <path fill="#E1E8ED" d="M12 0v16.555L16.429 20h3.142L24 16.555V0z" />
      <path fill="#DD2E44" d="M14 0v18.111L16.429 20h3.142L22 18.111V0z" />
      <path
        className={cssMedal}
        d="M21.902 21.02c.06-.163.098-.337.098-.52 0-.828-.672-1.5-1.5-1.5h-5c-.829 0-1.5.672-1.5 1.5 0 .183.038.357.098.52C11.654 22.389 10 25 10 28c0 4.418 3.581 8 8 8 4.418 0 8-3.582 8-8 0-3-1.654-5.611-4.098-6.98z"
      />
      <circle fill="#FFD983" cx="18" cy="28" r="6" />
      <path
        className={cssMedal}
        d="M20.731 32.36c-.119 0-.237-.036-.339-.109L18 30.535l-2.393 1.716c-.204.146-.477.146-.68-.002-.203-.147-.288-.407-.212-.645l.892-2.88-2.371-1.671c-.202-.149-.285-.41-.208-.648.078-.238.299-.399.549-.401L16.514 26l.935-2.809c.079-.238.301-.398.551-.398.25 0 .472.16.551.398L19.47 26l2.952.004c.251.002.472.163.549.401.077.238-.006.499-.208.648l-2.371 1.671.892 2.88c.076.238-.01.498-.212.645-.101.074-.221.111-.341.111z"
      />
    </SvgIcon>
  );
};

export default memo(MedalIcon);
